import React, { useEffect, useState } from 'react'
import 'feather-icons'
import { withRouter } from 'react-router-dom'
import { TYPE } from '../Theme'
import { PageWrapper, FullWrapper } from '../components'
import Panel from '../components/Panel'
import LPList from '../components/LPList'
import styled from 'styled-components'
import AccountSearch from '../components/AccountSearch'
import { useTopLps } from '../contexts/GlobalData'
import LocalLoader from '../components/LocalLoader'
import { RowBetween } from '../components/Row'
import { useStakingRewardsAddresses } from '../contexts/GlobalData'
import ScrollUp from '../components/ScrollUp'

const AccountWrapper = styled.div`
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

function AccountLookup() {
  // scroll to top
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  let topLpsList = useTopLps()
  const [topLps, setTopLps] = useState([])

  // To hide stakingRewardsContractAddresses
  const stakingContractAddrList = useStakingRewardsAddresses()
  useEffect(() => {
    if (topLpsList?.length > 0 && stakingContractAddrList?.length > 0) {
      setTopLps(topLpsList.filter((lp) => {
        return !stakingContractAddrList.includes((lp?.user?.id).toLowerCase())
      }))
    }
  }, [stakingContractAddrList, topLpsList])

  return (
    <PageWrapper>
      <FullWrapper>
        <ScrollUp />
        <RowBetween>
          <TYPE.largeHeader>Wallet analytics</TYPE.largeHeader>
        </RowBetween>
        <AccountWrapper>
          <AccountSearch />
        </AccountWrapper>
        <TYPE.main fontSize={'1.125rem'} style={{ marginTop: '2rem' }}>
          Top Liquidity Positions
        </TYPE.main>
        <Panel>{topLps && topLps.length > 0 ? <LPList lps={topLps} maxItems={200} /> : <LocalLoader />}</Panel>
      </FullWrapper>
    </PageWrapper>
  )
}

export default withRouter(AccountLookup)
